import { type MantineSize } from '@mantine/core';
import styles from '@/styles/exports.module.scss';

const getScaledValue = (value: string): string => `calc(${value} * var(--mantine-scale))`;

export const CONTROL_SIZES: Record<MantineSize, string> = {
  xs: getScaledValue(styles.controlSizeXS),
  sm: getScaledValue(styles.controlSizeSM),
  md: getScaledValue(styles.controlSizeMD),
  lg: getScaledValue(styles.controlSizeLG),
  xl: getScaledValue(styles.controlSizeXL),
};

export const getButtonFontSize = (size: MantineSize) => {
  switch (size) {
    case 'xs':
      return styles.fontSizeXS;
    case 'sm':
      return styles.fontSizeSM;
    case 'lg':
      return styles.fontSizeLG;
    case 'xl':
      return styles.fontSizeXL;

    default:
      return styles.fontSizeMD;
  }
};
